import { isNil } from "lodash-es";
import { ReactNode, createContext, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useComplexState } from "use-complex-state";
import { DelaysParetoReducer } from "../reducers/DelaysParetoReducer";

const DelaysParetoContext = createContext({
	state: DelaysParetoReducer.getInitialState(),
	actions: DelaysParetoReducer.actions,
});

export const useDelaysParetoContext = () => useContext(DelaysParetoContext);

export const DelaysParetoProvider = ({
	children,
}: {
	children: ReactNode;
}) => {
	const { shiftId: shiftIdParam } = useParams();

	const [state, actions] = useComplexState({
		initialState: DelaysParetoReducer.getInitialState(),
		reducers: DelaysParetoReducer.caseReducers,
	});
	useEffect(() => {
		const shiftId = Number(shiftIdParam);
		if (isNil(shiftIdParam) || isNaN(shiftId)) {
			actions.setShiftId(null);
		} else {
			actions.setShiftId(shiftId);
		}
	}, [shiftIdParam]);
	return (
		<DelaysParetoContext.Provider value={{ state, actions }}>
			{children}
		</DelaysParetoContext.Provider>
	);
};
